import { Injectable } from '@angular/core';
import { Pageable } from '@nimmsta/ng-commons-lib/models';
import {
  SFSOptions,
  WorkflowDataService,
} from '@nimmsta/ng-commons-lib/data-access';
import { Observable, map } from 'rxjs';
import { WorkflowExecution } from '../models/workflowExecution';

@Injectable({
  providedIn: 'root',
})
export class WorkflowExecutionService extends WorkflowDataService<WorkflowExecution> {
  private _currentWorkflowId!: string;

  protected override get apiEndpoint(): string {
    return '/workflow-execution';
  }

  public get currentWorkflowId(): string {
    return this._currentWorkflowId;
  }

  public set currentWorkflowId(id: string) {
    this._currentWorkflowId = id;
  }

  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<WorkflowExecution>> {
    options.sortColumn = 'lastUpdatedAt';
    options.sortOrder = 'desc';
    const params = this.getParams(options);
    return this.http.get<Pageable<WorkflowExecution>>(
      `${this.baseUrl + this.apiEndpoint}/workflow/${this.currentWorkflowId}`,
      {
        params,
      },
    ).pipe(map((page) => {
      page.content = page.content.map((item) => this.loadedDataTransform(item));
      return page;
    }));
  }
}
